import React from "react"
import { Spinner } from "reactstrap"

const Loader = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Spinner
        className="m-5"
        style={{
          height: "3rem",
          width: "3rem",
        }}
        color="primary"
      />
    </div>
  )
}

export default Loader
